<template>
  <Toast position="bottom-center" group="bc" />
</template>
<script lang="ts" setup>
  import { provide } from 'vue'
  import { Message } from '../models/message'

  import { useToast } from 'primevue/usetoast'
  import useNotifications from '@/store/notification'

  const notificationStore = useNotifications()
  const toast = useToast()

  notificationStore.$subscribe((_, state) => {
    const { severity, summary, detail } = state.notify
    toast.add({ severity, summary, detail, life: 3000, group: 'bc' })
  })

  provide('toastNotify', (args: Message) => {
    const { severity, summary, detail } = args
    notificationStore.notify = { severity, summary, detail }
  })

  const denyToast = () => {
    toast.removeGroup('bc')
  }
  // Have not figured out how to make this function useable
  const acceptToast = () => {
    toast.removeGroup('bc')
  }
</script>
